import { css } from 'styled-components';

export const anchorToSection = css`
  color: inherit;
  text-decoration: inherit;
`;
